// extracted by mini-css-extract-plugin
export default {"image":"Home_image__dxFyw","home":"Home_home__CMw1J","texto":"Home_texto__E31IE","redes":"Home_redes__tgkb8","fotologo":"Home_fotologo__ed1eQ","logo":"Home_logo__oiCAS"};